import { Link } from 'react-router-dom'
import type { Document } from '../../types'

interface DocumentCardProps {
  document: Document
}

const typeLabels: Record<string, string> = {
  master: 'Master Document',
  book: 'Book',
  strategy: 'Strategy',
  research: 'Research',
  presentation: 'Presentation',
  brand: 'Brand',
}

const statusColors: Record<string, string> = {
  draft: 'bg-mist-gray',
  review: 'bg-muted-gold',
  final: 'bg-seal-red',
}

export default function DocumentCard({ document }: DocumentCardProps) {
  return (
    <Link
      to={`/dashboard/edit/${document.slug}`}
      className="block bg-white border border-muted-gold p-5 rounded-sm hover:shadow-md transition-shadow group"
    >
      <div className="flex items-start justify-between mb-3">
        <span className={`text-xs px-2 py-1 rounded text-white ${statusColors[document.status]}`}>
          {document.status}
        </span>
        <span className="text-xs text-mist-gray">
          {typeLabels[document.type] || document.type}
        </span>
      </div>
      
      <h3 className="font-serif text-lg text-ink-black group-hover:text-seal-red transition-colors mb-2">
        {document.title}
      </h3>
      
      <div className="flex items-center justify-between text-sm text-mist-gray">
        <span>{document.wordCount.toLocaleString()} words</span>
        <span>{new Date(document.updatedAt).toLocaleDateString()}</span>
      </div>
    </Link>
  )
}